import { Form, FormBuilder,FormEdit } from "@formio/react"
import { useState, useRef } from "react"
import { CCol, CRow, CCard, CCardBody, CDropdown,CDropdownToggle ,CDropdownMenu,CDropdownItem ,CButtonGroup,
  CCardTitle, CCardText, CCardImage, CButton,CAccordion,CAccordionBody,CAccordionHeader,CAccordionItem , CFormSelect, CCardHeader, CCardFooter } from '@coreui/react'
  import { CModal, CModalBody, CModalHeader,CModalFooter, CFormLabel } from '@coreui/react'
  import {AddPatientForm} from './constants'

import Modal from 'react-bootstrap/Modal';
import { Button, Card, Dropdown } from "react-bootstrap"
import Select from 'react-select';
import './Builder.css'
import axios from 'axios'
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import ManageDynamicForm from "../../services/general/manageDynamicForms.api";
import Fn_FacilityDetailsCRUD from "../../services/general/facilityDetailsCRUD.api";
import FacilityTypeFn from "../../services/general/modifyFacilityType.api";

import { useEffect } from "react";

const PatientFormBuilder = () => {
  const [jsonSchema, setSchema] = useState({components: []})
  const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const selectedDiagnosis = useRef("")

  const [facilityType, setFacilityType] = useState(["ALF","SNF","ILF","Memory care","Mixed"])
  const formioOptions = {
    noDefaultSubmitButton: true,
    builder:{
           basic: {
          title: 'Basic Options',
          weight: 10,
          components: {
              question: {
                  title: 'Select Option/ Dropdown',
                  schema: {
                      label: '',
                      type: 'select',
                  }
              },
              questionText: {
                title: 'Text Input',
                schema: {
                    label: '',
                    type: 'textfield',
                }
            },
            questionNumber: {
              title: 'Number Input',
              schema: {
                  label: '',
                  type: 'number',
              }
          }
             
          }
      }
    }
  //   builder:{
  //     basic: {
  //       title: 'Basic',
  //       weight: 0,
  //       default: true,
  //       components: {
  //         select:{
  //           title:"Questions",
  //           key:"select",
  //           icon: 'terminal',
  //           schema: {
  //             label: 'Question',
  //             type: 'select',
             
  //             input: true
  //         }
  //         }
  //       }
  //     },
 
  // }
  };

  
  const [diagnosisData, setDiagnosisData] = useState([])
  const getData = async () => {

    let a = await ManageDynamicForm("Patient","","admin","select")
    if (a.d == "") {
      setSchema({components: []})
      
    } else {
      let temp = JSON.parse(a.d)
      setSchema(temp)
    }

 
  }
  useEffect(()=> {
    let resp = getData()
  },[])

  const handleSave = async () => {
  
    let a = await ManageDynamicForm("Patient",JSON.stringify(jsonSchema),"admin","update")
    alert("Form Saved")
  };
  return (
    <>

<div className="row">
                    <div className="col-md-6 offset-md-3">
    <div className="form-row">
          <CCard  title="Form" className="my-4">
            <CCardHeader>
            <CCardTitle className="text-center">Save Patient Form</CCardTitle>
            </CCardHeader>
          <CCardBody>
      </CCardBody><CCardFooter>
      <Button variant="primary" onClick={handleShow}>
        View Form
      </Button>
      <Button variant="primary" onClick={handleSave} style={{marginLeft:'10px'}}>
        Save Form
      </Button>
      </CCardFooter>
                                 
                                  </CCard>
                                   
                                    </div>
                                    </div>
                                    </div>
 
      
      <FormBuilder options={formioOptions} form={jsonSchema} onChange={(schema) => setSchema(schema)} />
      
      {/* <Card title="Form JSON Schema" className="my-4">
      <Card.Body>
        <Card.Title className="text-center">Form JSON Schema</Card.Title>
          <ReactJson src={jsonSchema} collapsed={true}></ReactJson>
      </Card.Body>
      </Card> */}
      {/* <Card className="my-4">
      <Card.Body>
        <Card.Title className="text-center">Form Render</Card.Title>
        
      </Card.Body>
      </Card> */}
                   
                   <div className="row">
                    <div className="col-md-6 offset-md-3">
                    <div  className="my-4" >

                          </div>
</div>
</div>
      
      <Modal size="lg"  show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Form Render</Modal.Title>
        </Modal.Header>
        <Modal.Body><Form form={jsonSchema}/></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
         
        </Modal.Footer>
      </Modal>

    </>
  )
}
export default PatientFormBuilder